import React from "react";
import t from "../../../assets/photos/3rd.jpg";

const Professionals = () => {
  return (
    <div className="w-full min-h-screen bg-gray-100 flex items-center justify-center">
      {/* Main Container */}
      <div className="flex w-full h-full flex-col-reverse lg:flex-row">
        {/* Left Section: Text Content */}
        <div className="w-full lg:w-1/2 px-8 py-12 flex flex-col justify-center">
          <h1 className="text-3xl lg:text-5xl font-semibold text-blue-900 mb-6">
            Professionals
          </h1>
          <p className="text-gray-700 text-base lg:text-lg leading-relaxed mb-6">
            Take the <span className="font-bold">next step in your professional journey</span>{" "}
            with us. Whether you're seeking{" "}
            <span className="font-bold">new challenges</span>,{" "}
            <span className="font-bold">greater opportunities</span> for growth, or a
            chance to apply your skills in an exciting and{" "}
            <span className="font-bold">dynamic environment</span>, we have the perfect
            opportunity for you.
          </p>
          <p className="text-gray-700 text-base lg:text-lg mb-8">
            Join us and be part of a team that makes a difference!
          </p>
          <button className="bg-black text-white px-6 py-3 rounded hover:bg-gray-700 transition duration-300">
            Explore our professions
          </button>
        </div>

        {/* Right Section: Image */}
        <div className="w-full lg:w-1/2 h-64 lg:h-auto">
          <img
            src={t}
            alt="Professionals at CodeQueue"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Professionals;
